import React from 'react';
import { Stack } from '@mui/material';
import SlmReports from '../reports/SlmReports';
import CensusReports from '../reports/CensusReports';
import DocumentBundleDownload from '../reports/downloads/document-bundle-download';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { documentBundleDownload, reportsDownloadDailyCensus } from 'src/config';

const DepartmentDownloads: React.FC = () => {
  const [isDocumentBundleDownloadEnabled] = useFeatureToggleWhenReady(
    documentBundleDownload,
    'ENTERPRISE'
  );
  const [isDailyCensusEnabled] = useFeatureToggleWhenReady(
    reportsDownloadDailyCensus,
    'ENTERPRISE'
  );

  return (
    <Stack
      gap="2rem"
      sx={{ width: '100%', height: '100%', padding: '2rem 2rem 2rem 4rem' }}
    >
      {isDailyCensusEnabled && <CensusReports />}
      <SlmReports />
      {isDocumentBundleDownloadEnabled && <DocumentBundleDownload />}
    </Stack>
  );
};

export default DepartmentDownloads;
